<template>
  <div class="wrp">
    <header style="padding: 0 16px;">
      <p style="font-weight:400;font-size: 16px" @click="back">返回</p>
      <p style="opacity: 0">返回</p>
    </header>
    <div class="content-box">
      <div class="content">
        <div class="contnt-title">
          <div class="contnt-title">
            <p :style="{color: '#2196F3'}" v-show="invoiceInfo.checkFlag == 1">验真成功</p>
            <p :style="{color: '#FF0000'}" v-show="invoiceInfo.checkFlag == 0 && (invoiceInfo.invoiceType === '01' || invoiceInfo.invoiceType === '04' || invoiceInfo.invoiceType === '10' || invoiceInfo.invoiceType === '11')">验真失败</p>
            <span v-if="!invoiceInfo.checkFlag && !(invoiceInfo.invoiceType === '01' || invoiceInfo.invoiceType === '04' || invoiceInfo.invoiceType === '10' || invoiceInfo.invoiceType === '11')" style="color:#999999">未验真</span>
            <span :style="{color: '#FF0000'}" v-if="invoiceInfo.ext5 == 1">&nbsp;抬头异常</span>
          </div>
          <p>
            <i v-if="!invoiceInfo.commitFlag && !invoiceInfo.checkFlag" class="basicmobilefont" style="margin-right:15px;" @click="overlayVisible = true">&#xe6ad;</i>
            <i v-if="!invoiceInfo.commitFlag" class="basicmobilefont" @click="delInvoice">&#xe6a9;</i>
          </p>
        </div>
        <div class="invoice-type">
          <p v-if="invoiceInfo.invoiceType === '01' || invoiceInfo.invoiceType === '04' || invoiceInfo.invoiceType === '10' || invoiceInfo.invoiceType === '11' || invoiceInfo.invoiceType === '200'" style="border-width: 1px" class="invoice-type-c-inside"></p>
          <p v-if="invoiceInfo.invoiceType === '01' || invoiceInfo.invoiceType === '04' || invoiceInfo.invoiceType === '10' || invoiceInfo.invoiceType === '11' || invoiceInfo.invoiceType === '200'" style="border-width: 2px" class="invoice-type-c-outside"></p>
          <i v-if="invoiceInfo.invoiceType === '201'" class="basicmobilefont type-icon">&#xe6c0;</i>
          <i v-if="invoiceInfo.invoiceType === '207'" class="basicmobilefont type-icon">&#xe6c1;</i>
          <i v-if="invoiceInfo.invoiceType === '202'" class="basicmobilefont type-icon">&#xe6bf;</i>
          <p class="invoice-type-text">{{invoiceInfo.invoiceTypeName}}</p>
        </div>
        <div class="invoice-basic">
          <van-cell-group v-show="invoiceInfo.ocrSellerName" :border="false">
            <van-field
              label="销方名称"
            >
              <p slot="input" class="input">{{invoiceInfo.checkFlag == 1 ? invoiceInfo.sellerName : invoiceInfo.ocrSellerName}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.ocrDrewDate" :border="false">
            <van-field
              label="开票日期"
            >
              <p slot="input" class="input">{{invoiceInfo.ocrDrewDate}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.drewDate && !invoiceInfo.ocrDrewDate" :border="false">
            <van-field
              label="开票日期"
            >
              <p slot="input" class="input">{{invoiceInfo.drewDate}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.invoiceCode" :border="false">
            <van-field
              label="发票代码"
            >
              <p slot="input" class="input">{{invoiceInfo.ocrInvoiceCode || invoiceInfo.invoiceCode}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.invoiceNo || invoiceInfo.ocrInvoiceNo" :border="false">
            <van-field
              label="发票号码"
            >
              <p slot="input" v-if="invoiceInfo.invoiceNo" class="input">{{invoiceInfo.invoiceNo}}</p>
              <p slot="input" v-if="!invoiceInfo.invoiceNo" class="input">{{invoiceInfo.ocrInvoiceNo}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.passengerName" :border="false">
            <van-field
              label="乘机人姓名"
            >
              <p slot="input" class="input">{{invoiceInfo.passengerName}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.mileage" :border="false">
            <van-field
              label="里程"
            >
              <p slot="input" class="input">{{invoiceInfo.mileage}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.place" :border="false">
            <van-field
              label="地点"
            >
              <p slot="input" class="input">{{invoiceInfo.place}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-if="invoiceInfo.detailList && invoiceInfo.detailList.length" :border="false">
            <van-field
              label="起始地"
            >
              <p slot="input" class="input">{{invoiceInfo.detailList[0].flyFrom}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-if="invoiceInfo.detailList && invoiceInfo.detailList.length" :border="false">
            <van-field
              label="客票号码"
            >
              <p slot="input" class="input">{{invoiceInfo.detailList[0].ticketId}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.checkCode" :border="false">
            <van-field
              label="验证码"
            >
              <p slot="input" class="input">{{invoiceInfo.checkCode}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.caacDevelopmentFund" :border="false">
            <van-field
              label="民航发展基金"
            >
              <p slot="input" class="input">{{invoiceInfo.caacDevelopmentFund}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.caacDevelopmentFund" :border="false">
            <van-field
              label="燃油附加费"
            >
              <p slot="input" class="input">{{invoiceInfo.fuelSurcharge}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.getOnDate" :border="false">
            <van-field
              label="乘车日期"
            >
              <p slot="input" class="input">{{invoiceInfo.getOnDate}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.timeGetOn" :border="false">
            <van-field
              label="上车时间"
            >
              <p slot="input" class="input">{{invoiceInfo.timeGetOn}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.timeGetOff" :border="false">
            <van-field
              label="下车时间"
            >
              <p slot="input" class="input">{{invoiceInfo.timeGetOff}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.trainNumber" :border="false">
            <van-field
              label="车次"
            >
              <p slot="input" class="input">{{invoiceInfo.trainNumber}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.seat" :border="false">
            <van-field
              label="座位类型"
            >
              <p slot="input" class="input">{{invoiceInfo.seat}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.stationGetOn" :border="false">
            <van-field
              label="上车车站"
            >
              <p slot="input" class="input">{{invoiceInfo.stationGetOn}}</p>
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.stationGetOff" :border="false">
            <van-field
              label="下车车站"
            >
              <p slot="input" class="input">{{invoiceInfo.stationGetOff}}</p>
            </van-field>
          </van-cell-group>
        </div>
        <div @click="openSellerInfo" v-if="invoiceInfo.checkFlag && (invoiceInfo.invoiceType === '01' || invoiceInfo.invoiceType === '04' || invoiceInfo.invoiceType === '10' || invoiceInfo.invoiceType === '11')" class="seller-info-wrp">
          <van-divider />
          <p class="title">
            <span style="font-size: 14px">购销方信息</span>
            <van-icon v-show="!openSeller" style="font-size: 12px" name="arrow-down" />
            <van-icon v-show="openSeller" style="font-size: 12px" name="arrow-up" />
          </p>
          <div v-show="openSeller">
            <van-cell-group :border="false">
              <van-field
                label="销方名称"
              >
                <p slot="input" class="input">{{invoiceInfo.sellerName}}</p>
              </van-field>
            </van-cell-group>
            <van-cell-group :border="false">
              <van-field
                label="销方税号"
              >
                <p slot="input" class="input">{{invoiceInfo.sellerTaxNo}}</p>
              </van-field>
            </van-cell-group>
            <van-cell-group :border="false">
              <van-field
                label="地址/电话"
              >
                <p slot="input" class="input">{{invoiceInfo.sellerAddressTel}}</p>
              </van-field>
            </van-cell-group>
            <van-cell-group :border="false">
              <van-field
                label="开户行/账号"
              >
                <p slot="input" class="input">{{invoiceInfo.sellerBankNameAcc}}</p>
              </van-field>
            </van-cell-group>
            <van-divider />
            <van-cell-group :border="false">
              <van-field
                label="购方名称"
              >
                <p slot="input" class="input">{{invoiceInfo.purchaserName}}</p>
              </van-field>
            </van-cell-group>
            <van-cell-group :border="false">
              <van-field
                label="购方税号"
              >
                <p slot="input" class="input">{{invoiceInfo.purchaserTaxNo}}</p>
              </van-field>
            </van-cell-group>
            <van-cell-group :border="false">
              <van-field
                label="地址/电话"
              >
                <p slot="input" class="input">{{invoiceInfo.purchaserAddressTel}}</p>
              </van-field>
            </van-cell-group>
            <van-cell-group :border="false">
              <van-field
                label="开户行/账号"
              >
                <p slot="input" class="input">{{invoiceInfo.purchaserBank}}</p>
              </van-field>
            </van-cell-group>
          </div>
        </div>
        <van-divider dashed />
        <div class="invoice-detail" v-if="type === 1">
          <p class="invoice-detail-title">商品明细</p>
          <div class="detail-title">
            <div class="name">品名</div>
            <div class="price">单价</div>
            <div class="count">数量</div>
            <div class="sum">金额</div>
          </div>
          <div
            v-show="consumerDetails.length"
            v-for="(val, key) in consumerDetails"
            :key="key"
            class="detail-item"
          >
            <div class="name">{{val.goodsName}}</div>
            <div class="price">{{convertNumber(val.unitPrice)}}</div>
            <div class="count">{{val.quantity}}</div>
            <div class="sum">{{convertNumber(val.amount)}}</div>
          </div>
          <van-divider />
          <div class="detail-item" v-show="!consumerDetails.length">
            无明细信息
          </div>
          <!-- <div style="text-align:center;color: #666666" v-show="consumerDetails.length > 5">
            ...
          </div> -->
        </div>
        <div class="invoice-amount" @click="startEditMoney">
          <p style="color: #333333">发票金额</p>
          <p v-show="!editMoney" style="color: #2196F3;font-weight:bold">¥{{convertNumber(invoiceInfo.ocrAmountWithTax || invoiceInfo.amountWithTax)}}</p>
          <input @blur="editMoney = false" v-show="editMoney" style="text-align: right;color: #2196F3;font-weight:bold" v-model="invoiceInfo.ocrAmountWithTax" />
        </div>
        <div v-if="invoiceInfo.ocrTaxAmount || invoiceInfo.taxAmount" @click="startEditMoney" class="invoice-amount">
          <p style="color: #333333">发票税额</p>
          <p v-if="!editMoney&&invoiceInfo.ocrTaxAmount" style="color: #2196F3;font-weight:bold">¥{{convertNumber(invoiceInfo.ocrTaxAmount)}}</p>
          <p v-if="invoiceInfo.taxAmount&&(invoiceInfo.invoiceType == 207 || invoiceInfo.invoiceType == 202)" style="color: #2196F3;font-weight:bold">¥{{convertNumber(invoiceInfo.taxAmount)}}</p>
          <input @blur="editMoney = false" v-show="editMoney" style="text-align: right;color: #2196F3;font-weight:bold" v-model="invoiceInfo.ocrTaxAmount" />
        </div>
        <div v-if="invoiceInfo.ocrAmount" @click="startEditMoney" class="invoice-amount">
          <p style="color: #333333">不含税金额</p>
          <p v-show="!editMoney" style="color: #2196F3;font-weight:bold">¥{{convertNumber(invoiceInfo.ocrAmount)}}</p>
          <input @blur="editMoney = false" v-show="editMoney" style="text-align: right;color: #2196F3;font-weight:bold" v-model="invoiceInfo.ocrAmount" />
        </div>
        <van-divider dashed />
        <div class="operation">
          <p @click="invoiceImage.imagePreviewVisible = true">
            <i class="basicmobilefont">&#xe6af;</i>
            <span>查看发票影像</span>
          </p>
          <p @click="reCheck" v-show="!invoiceInfo.checkFlag && (invoiceInfo.invoiceType == '01' || invoiceInfo.invoiceType == '04' || invoiceInfo.invoiceType == '10' || invoiceInfo.invoiceType == 11)">
            <i class="basicmobilefont">&#xe6b0;</i>
            <span>重新查验</span>
          </p>
          <!-- <p>
            <i class="basicmobilefont">&#xe6b6;</i>
            <span>发送至邮箱</span>
          </p> -->
        </div>
        <div class="tips">
          <p style="margin-bottom: 20px">特别提示：</p>
          <p>本平台仅提供所查询发票票面信息的查验结果，若发现发票查询结果与实际交易不符，任何单位或个人有权拒收并向当地税务机关举报。</p>
        </div>
      </div>
    </div>
    <ImagePreview @onClose="invoiceImage.imagePreviewVisible = false" :visible="invoiceImage.imagePreviewVisible" :img="invoiceImage.src" />
    <van-popup v-model="overlayVisible" :close-on-click-overlay="false" style="background: transparent" class="content-wrapper">
      <div class="invoice-update-wrp">
        <div class="title" style="display: flex; width: 100%; justify-content: flex-end">
          <van-icon style="margin-right: 20px;" color="#000" name="cross" @click="overlayVisible = false" />
        </div>
        <div style="margin: 20px 0;">
          <van-cell-group v-show="invoiceInfo.ocrSellerName" :border="false">
            <van-field
              label="销方名称"
            >
              <input slot="input" class="input" type="text" v-model="editData.ocrSellerName">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.ocrDrewDate" :border="false">
            <van-field
              label="开票日期"
            >
              <input slot="input" class="input" type="text" v-model="editData.ocrDrewDate">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.drewDate && !invoiceInfo.ocrDrewDate" :border="false">
            <van-field
              label="开票日期"
            >
              <input slot="input" class="input" type="text" v-model="editData.drewDate">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.invoiceCode" :border="false">
            <van-field
              label="发票代码"
            >
              <input v-show="invoiceInfo.ocrInvoiceCode" slot="input" class="input" type="text" v-model="editData.ocrInvoiceCode">
              <input v-show="!invoiceInfo.ocrInvoiceCode" slot="input" class="input" type="text" v-model="editData.invoiceCode">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.invoiceNo || invoiceInfo.ocrInvoiceNo" :border="false">
            <van-field
              label="发票号码"
            >
              <input slot="input" v-show="invoiceInfo.invoiceNo" class="input" type="text" v-model="editData.ocrInvoiceNo">
              <input slot="input" v-show="!invoiceInfo.ocrInvoiceNo" class="input" type="text" v-model="editData.invoiceNo">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.ocrAmount && invoiceInfo.invoiceType === '01'" :border="false">
            <van-field
              label="不含税金额"
            >
              <input slot="input" class="input" type="text" v-model="editData.ocrAmount">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.passengerName" :border="false">
            <van-field
              label="乘机人姓名"
            >
              <input slot="input" class="input" type="text" v-model="editData.passengerName">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.mileage" :border="false">
            <van-field
              label="里程"
            >
              <input slot="input" class="input" type="text" v-model="editData.mileage">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.place" :border="false">
            <van-field
              label="地点"
            >
              <input slot="input" class="input" type="text" v-model="editData.place">
            </van-field>
          </van-cell-group>
          <van-cell-group v-if="invoiceInfo.detailList && invoiceInfo.detailList.length" :border="false">
            <van-field
              label="起始地"
            >
              <input slot="input" class="input" type="text" v-model="editData.detailList[0].flyFrom">
            </van-field>
          </van-cell-group>
          <van-cell-group v-if="invoiceInfo.detailList && invoiceInfo.detailList.length" :border="false">
            <van-field
              label="客票号码"
            >
              <input slot="input" class="input" type="text" v-model="editData.detailList[0].ticketId">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.checkCode" :border="false">
            <van-field
              label="验证码"
            >
              <input slot="input" class="input" type="text" v-model="editData.checkCode">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.ountWithTax && invoiceInfo.invoiceType === '202'" :border="false">
            <van-field
              label="金额（含税）"
            >
              <input slot="input" class="input" type="text" v-model="editData.ountWithTax">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.fare && invoiceInfo.invoiceType === '202'" :border="false">
            <van-field
              label="票价"
            >
              <input slot="input" class="input" type="text" v-model="editData.fare">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.caacDevelopmentFund" :border="false">
            <van-field
              label="民航发展基金"
            >
              <input slot="input" class="input" type="text" v-model="editData.caacDevelopmentFund">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.caacDevelopmentFund" :border="false">
            <van-field
              label="燃油附加费"
            >
              <input slot="input" class="input" type="text" v-model="editData.fuelSurcharge">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.getOnDate" :border="false">
            <van-field
              label="乘车日期"
            >
              <input slot="input" class="input" type="text" v-model="editData.getOnDate">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.timeGetOn" :border="false">
            <van-field
              label="上车时间"
            >
              <input slot="input" class="input" type="text" v-model="editData.timeGetOn">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.timeGetOff" :border="false">
            <van-field
              label="下车时间"
            >
              <input slot="input" class="input" type="text" v-model="editData.timeGetOff">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.trainNumber" :border="false">
            <van-field
              label="车次"
            >
              <input slot="input" class="input" type="text" v-model="editData.trainNumber">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.seat" :border="false">
            <van-field
              label="座位类型"
            >
              <input slot="input" class="input" type="text" v-model="editData.seat">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.stationGetOn" :border="false">
            <van-field
              label="上车车站"
            >
              <input slot="input" class="input" type="text" v-model="editData.stationGetOn">
            </van-field>
          </van-cell-group>
          <van-cell-group v-show="invoiceInfo.stationGetOff" :border="false">
            <van-field
              label="下车车站"
            >
              <input slot="input" class="input" type="text" v-model="editData.stationGetOff">
            </van-field>
          </van-cell-group>
        </div>
        <div class="f-upload">
          <van-button type="info" @click="submit">提交</van-button>
          <van-button type="info" @click="updateInvoice">保存</van-button>
        </div>
      </div>
    </van-popup>
    <MyActionSheet
      :columns="companyNameList"
      :visible="companyData.visible"
      @cancel="companyData.visible = false"
      @confirm="onCompanyConfirm"
      type="companyList"
    />
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Popup,
  Field,
  Button,
  picker,
  DatetimePicker,
  Toast,
  Notify,
  Divider,
  Dialog,
  Icon
} from 'vant'
import ImagePreview from '@components/ImagePreview'
import { getQuery, ConvertNumber, deepCopy } from '@utils/basicUtil'
import moment from 'moment'
import { officialAccountRequest } from '@services'
import MyActionSheet from '@components/OfficialAccount/ActionSheet'

export default {
  data () {
    return {
      consumerDetails: [],
      invoiceImage: {
        imagePreviewVisible: false,
        src: ''
      },
      type: 0,
      id: '',
      invoiceInfo: {},
      editData: {},
      openSeller: false,
      editMoney: false,
      overlayVisible: false,
      companyData: {
        visible: false,
        companyId: ''
      },
      officialAccountId: '',
      submitType: ''
    }
  },
  computed: {
    companyNameList () {
      return this.$store.state.officialAccount.companyNameList
    },
    companyList () {
      return this.$store.state.officialAccount.companyList
    }
  },
  mounted () {
    this.getQuery()
    this.getInvoiceDetail()
  },
  methods: {
    getQuery () {
      this.id = getQuery().id
      this.type = Number(getQuery().type)
    },
    moment (data) {
      return moment(Number(data)).format('YYYY-MM-DD')
    },
    back () {
      this.$router.push('/official-account/manager')
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    getInvoiceDetail () {
      if (this.type === 0) {
        this.getNonVat()
      } else {
        this.getVat()
      }
    },
    async getNonVat () {
      const data = await officialAccountRequest.weChat.getNonVat({}, { id: this.id })
      if (data.success) {
        this.invoiceImage.src = data.result.imagePath
        this.invoiceInfo = data.result
        this.editData = deepCopy(data.result)
        this.invoiceInfo.invoiceTypeName = this.invoiceTypeName(data.result.invoiceType)
      } else {
        Notify({ type: 'danger', message: data.message })
        this.$router.push('/official-account/manager')
      }
    },
    async getVat () {
      const data = await officialAccountRequest.weChat.getVat({}, { id: this.id })
      if (data.success) {
        this.invoiceImage.src = data.result.weChatVatInvoice.imagePath || data.result.weChatVatInvoice.ocrUrl
        this.invoiceInfo = data.result.weChatVatInvoice
        this.editData = deepCopy(data.result.weChatVatInvoice)
        this.invoiceInfo.invoiceTypeName = this.invoiceTypeName(data.result.weChatVatInvoice.invoiceType)
        this.consumerDetails = data.result.invoiceDetailList || []
      } else {
        Notify({ type: 'danger', message: data.message })
        this.$router.push('/official-account/manager')
      }
    },
    delInvoice () {
      Dialog.confirm({
        title: '提示',
        message: '确认删除该发票数据'
      }).then(() => {
        switch (this.invoiceInfo.invoiceType) {
          case '01':
            this.vatDel()
            break
          case '04':
            this.vatDel()
            break
          case '10':
            this.vatDel()
            break
          case '11':
            this.vatDel()
            break
          case '202':
            this.nonVatDel()
            break
          case '200':
            this.nonVatDel()
            break
          case '201':
            this.nonVatDel()
            break
          case '207':
            this.nonVatDel()
            break
          default:
            break
        }
      })
    },
    async nonVatDel () {
      const data = await officialAccountRequest.weChat.nonVatDel({}, { id: this.invoiceInfo.id })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功' })
        this.$router.push('/official-account/manager')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async vatDel () {
      const data = await officialAccountRequest.weChat.vatDel({}, { id: this.invoiceInfo.id })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功' })
        this.$router.push('/official-account/manager')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async reCheck () {
      Toast.loading({
        message: '发票查验中...',
        forbidClick: true,
        duration: 0
      })
      const data = await officialAccountRequest.weChat.vatCheck({ id: this.invoiceInfo.id })

      if (data.success) {
        Notify({ type: 'success', message: '查验完毕' })
        this.$router.push('/official-account')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      Toast.clear({
        clearAll: true
      })
    },
    invoiceTypeName (invoiceType) {
      switch (invoiceType) {
        case '01':
          return '增值税专用发票'
        case '04':
          return '增值税普通发票'
        case '10':
          return '增值税电子发票'
        case '11':
          return '增值税卷式发票'
        case '202':
          return '航空客票行程单'
        case '200':
          return '定额发票'
        case '201':
          return '火车票'
        case '207':
          return '出租车发票'
        default:
          break
      }
    },
    updateInvoice () {
      Dialog.confirm({
        title: '提示',
        message: '确认修改该发票数据'
      }).then(() => {
        switch (this.invoiceInfo.invoiceType) {
          case '01':
            this.vatUpdate()
            break
          case '04':
            this.vatUpdate()
            break
          case '10':
            this.vatUpdate()
            break
          case '11':
            this.vatUpdate()
            break
          case '202':
            this.nonVatUpdate()
            break
          case '200':
            this.nonVatUpdate()
            break
          case '201':
            this.nonVatUpdate()
            break
          case '207':
            this.nonVatUpdate()
            break
          default:
            break
        }
      })
    },
    async nonVatUpdate () {
      const data = await officialAccountRequest.weChat.nonVatUpdate({ ...this.editData })

      if (data.success) {
        Notify({ type: 'success', message: '修改成功' })
        this.$router.push('/official-account/manager')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async vatUpdate () {
      let newData = {}
      if (this.editData.invoiceType === '11' || this.editData.invoiceType === '04' || this.editData.invoiceType === '10') {
        newData.ocrCheckCode = this.editData.checkCode
      }
      const data = await officialAccountRequest.weChat.vatUpdate({ ...this.editData, ...newData })
      if (data.success) {
        Notify({ type: 'success', message: '修改成功' })
        this.$router.push('/official-account/manager')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    openSellerInfo () {
      this.openSeller = !this.openSeller
    },
    startEditMoney (e) {
      if (this.invoiceInfo.checkFlag) {
        return
      }
      if (!(this.invoiceInfo.invoiceType === '01' || this.invoiceInfo.invoiceType === '04' || this.invoiceInfo.invoiceType === '10' || this.invoiceInfo.invoiceType === '11')) {
        return
      }
      this.editMoney = true
    },
    submit () {
      switch (this.invoiceInfo.invoiceType) {
        case '01':
          this.submitType = 'vat'
          break
        case '04':
          this.submitType = 'vat'
          break
        case '10':
          this.submitType = 'vat'
          break
        case '11':
          this.submitType = 'vat'
          break
        case '200':
          this.submitType = 'non'
          break
        case '201':
          this.submitType = 'non'
          break
        case '202':
          this.submitType = 'non'
          break
        case '207':
          this.submitType = 'non'
          break
        default:
          break
      }
      if (this.companyList.length > 1) {
        this.overlayVisible = false
        this.companyData.visible = true
      } else {
        this.officialAccountId = this.companyList[0].id
        this.saveAndCommit()
      }
    },
    async nonVatCommit () {
      const data = await officialAccountRequest.weChat.nonVatEditAndCommit({ officialAccountId: this.officialAccountId, ticketInfo: { ...this.editData } })
      if (data.success) {
        Notify({ type: 'success', message: '提交成功' })
        this.$router.push('/official-account/manager')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async vatCommit () {
      let newData = {}
      if (this.editData.invoiceType === '11' || this.editData.invoiceType === '04' || this.editData.invoiceType === '10') {
        newData.ocrCheckCode = this.editData.checkCode
      }
      const data = await officialAccountRequest.weChat.vatEditAndCommit({ officialAccountId: this.officialAccountId, ticketInfo: { ...this.editData, ...newData } })
      if (data.success) {
        Notify({ type: 'success', message: '提交成功' })
        this.$router.push('/official-account/manager')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    onCompanyConfirm (data) {
      this.companyData.visible = false
      this.officialAccountId = data.value.id
      this.saveAndCommit()
    },
    saveAndCommit () {
      if (this.submitType === 'non') {
        this.nonVatCommit()
      } else {
        this.vatCommit()
      }
    }
  },
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [picker.name]: picker,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast,
    [Notify.name]: Notify,
    [Divider.name]: Divider,
    ImagePreview,
    [Icon.name]: Icon,
    MyActionSheet
  }
}
</script>

<style lang="less" scoped>
  .wrp {
    height: 100%;
    background-color: #2196F3;
    overflow: hidden;
  }
  .content-box {
    height: calc(100% - 100px);
    overflow: auto;
    padding: 0px 20px 50px 20px;
    margin-top: 20px;
    position: relative;
    background-image: url('../../assets/img/image.png');
    background-size: 100%;
    background-repeat: no-repeat;
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    height: 80px;
    font-family: 'PingFang SC';
    color:rgba(51,51,51,1);
  }
  .input {
    font-size: 26px;
    font-family: 'PingFang SC';
    font-weight: 500;
    color:rgba(153,153,153,1);
    width: 98%;
    text-align: right;
    border: none;
    padding: 0;
    margin: 0;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .f-upload {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .invoice-update-wrp {
    width: 80vw;
    background: #fff;
    padding: 20px 10px;
  }
  .seller-info-wrp {
    .title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 27px;
      font-family: 'PingFang SC';
      font-weight: 400;
      color:#323233;
      i {
        font-size: 12px;
        color: rgba(153,153,153,1);
        font-weight: 400;
      }
      .translate {
        transform: rotate(180);
      }
    }
  }
  .content {
    padding: 40px 40px 120px 40px;
    background: #fff;
    min-height: 600px;
    margin-top: 200px;
    margin-bottom: 40px;
    .contnt-title {
      color: #2196F3;
      font-size: 26px;
      font-family: 'PingFang SC';
      font-weight: 300;
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .invoice-type {
      position: relative;
      height: 120px;
      width: 100%;
      .type-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%);
        color: rgba(233,149,151,1);
        font-size: 30px;
      }
      .invoice-type-c-inside {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 161px;
        height: 94px;
        border: 1px solid rgba(233,149,151,1);
        border-radius: 50%;
      }
      .invoice-type-c-outside {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 182px;
        height: 106px;
        border: 2px solid rgba(233,149,151,1);
        border-radius: 50%;
      }
      .invoice-type-text {
        font-size: 34px;
        font-family: PingFang SC;
        font-weight: 500;
        color:rgba(141,40,32,1);
        width: fit-content;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -95%);
      }
    }
    .invoice-basic {
      margin-top: 20px;
      font-family: 'PingFang SC';
      .invoice-basic-title {
        font-size: 28px;
        font-weight: 400;
        color:rgba(51,51,51,1)
      }
      .invoice-basic-value {
        font-size: 28px;
        font-weight: 400;
        color:rgba(153,153,153,1)
      }
    }
    .invoice-detail {
      max-height: 450px;
      overflow: auto;
      .invoice-detail-title {
        font-size: 26px;
        font-family: 'PingFang SC';
        font-weight: 400;
        color:rgba(153,153,153,1);
      }
      .detail-title {
        font-size: 26px;
        font-weight: 500;
        color: #333333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        margin-bottom: 35px;
        margin-top: 50px;
      }
      .detail-item {
        font-size: 22px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 21px;
        letter-spacing: 2px;
      }
      .name {
        width: 25%;
        height: 100%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .price {
        width: 30%;
        height: 100%;
        text-align: right;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        margin-right: 10px;
      }
      .count {
        width: 15%;
        height: 100%;
        text-align: center;
      }
      .sum {
        width: 30%;
        height: 100%;
        text-align: right;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .invoice-amount {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 30px;
      font-family: 'PingFang SC';
      font-weight: 400;
    }
    .operation {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight:400;
      color:rgba(33,150,243,1);
      font-size:24px;
      margin-bottom: 110px;
      span {
        text-decoration:underline;
        margin-left: 5px;
      }
    }
    .tips {
      font-size: 20px;
      font-family: 'PingFang SC';
      font-weight: 400;
      color: rgba(255,0,0,1)
    }
    .van-cell {
      padding: 10px 0px !important;
    }
    .van-cell:not(:last-child)::after {
      width:100% !important;
      left: 0 !important;
    }
  }
</style>
